import { render, staticRenderFns } from "./RightMenu.vue?vue&type=template&id=fc553578"
import script from "./RightMenu.vue?vue&type=script&lang=ts"
export * from "./RightMenu.vue?vue&type=script&lang=ts"
import style0 from "./RightMenu.vue?vue&type=style&index=0&id=fc553578&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports